import {type AppState} from '../../types/app-state'
import {LoginStatus} from './state'

export const logInStatusSelector = (state: AppState): LoginStatus => state.sessionData.loginStatus

export const errorSelector = (state: AppState): string | undefined => state.sessionData.error

export const hasErrorSelector = (state: AppState): boolean =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    state.sessionData.error ? state.sessionData.error?.length > 0 : false

export const userLogInFlowSelector = (state: AppState): boolean => state.sessionData.userLogInFlow
